
import styles from './ProductActions.module.scss';

export const optionsActions = {
  theme: 'Sportscraft',
};

export const qtySelectorOptions = {
  customClasses: {
    selectDropdown: styles.selectDropdown,
    after: styles.afterQty,
  },
  selectHeight: '52px',
};

export const sizeSelectorOptions = {
  selectHeight: '52px',
};

export const measuresIconsReview = {
  widthIcon: '12px',
  heightIcon: '12px',
};
